import { Grid } from "@mui/material";
import { Form, Formik } from "formik";
import * as yup from "yup";

import { IAuthLoginDTO } from "../../../modules/user/models/IAuthService";

import { StyledGridContainer } from "../../../components/StyledLayout";

import SecurityAuthCard from "./SecurityAuthCard";
import { useSecurityAuth } from "./hook/useSecurityAuth";

export const SecurityAuthDefault: React.FC = () => {
  const { handleSubmit, handleResendCode, email, password } = useSecurityAuth();

  const validationSchema = yup.object().shape({
    mfaToken: yup.number().required("Este campo é obrigatório"),
  });

  return (
    <Formik
      initialValues={{ email, password, mfaToken: "" } as IAuthLoginDTO}
      validationSchema={validationSchema}
      onSubmit={handleSubmit}
    >
      {(props) => (
        <Form style={{ border: "0px solid red" }}>
          <StyledGridContainer>
            <Grid
              item
              xs={12}
              md={12}
              mt={{ xs: 6, md: 0 }}
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <SecurityAuthCard
                formikProps={props}
                email={email}
                onResendCode={handleResendCode}
              />
            </Grid>
          </StyledGridContainer>
        </Form>
      )}
    </Formik>
  );
};

export default SecurityAuthDefault;
